import HeaderCell from "components/table/HeaderCell";
import { 
	SORT_NEWEST_FIRST,
	SORT_OLDEST_FIRST
} from 'utils/constants';

const columns = [
  {
    name: <HeaderCell label={"Location Name"} />,
    selector: (row) => row.name,
    width: "230px",
  },
  {
    name: <HeaderCell label={"Phone Number"} />,
    selector: (row) => row.contact_name,
    width: "230px",
  },
  {
    name: <HeaderCell label={"Email Address"} />,
    selector: (row) => row.contact_email,
    width: "280px",
  },
  {
    name: <HeaderCell label={"Google Map Address"} />,
    selector: (row) => row.contact_phone_number,
    width: "220px",
  },
  {
    name: <HeaderCell label={"ACTION"} />,
    selector: (row) => row.action,
    // width: "140px",
  },
];

const sort = (data, sortOrder) => {
	if (!data)
		return [];
	if (!sortOrder)
		return data;
	let sortedData = [...data];
	if (sortOrder === SORT_NEWEST_FIRST)
		return sortedData.sort((a, b) => b?.id - a?.id);
	if (sortOrder === SORT_OLDEST_FIRST)
		return sortedData.sort((a, b) => a?.id - b?.id);
}

const search = (data, searchQuery) => {
	if (!data)
		return [];
	if (searchQuery === "")
		return data;
	const results = data.filter(location => {
		if (location?.id?.toString()?.includes(searchQuery))
			return true;
		if (location?.name?.toLowerCase()?.includes(searchQuery))
			return true;
		if (location?.address?.toLowerCase()?.includes(searchQuery))
			return true;
		if (location?.postcode?.toLowerCase()?.includes(searchQuery))
			return true;
		if (location?.contact_name?.toLowerCase()?.includes(searchQuery))
			return true;
		if (location?.contact_email?.toLowerCase()?.includes(searchQuery))
			return true;
		if (location?.contact_phone_number?.toLowerCase()?.includes(searchQuery))
			return true;
		return false;
	});
	return results;
}

export { columns, sort, search };